document.addEventListener('gform_confirmation_loaded', function(event, formId){
    // Ajout d'un petit délai pour s'assurer que la page a bien été chargée avant de scroller
    setTimeout(function() {
        // Scroll vers le bas de la page
        window.scrollTo(0, document.body.scrollHeight);
    }, 100); // Délai de 100ms, vous pouvez ajuster ce délai si nécessaire
}, false);
